import { Pipe, PipeTransform } from '@angular/core';
import { TemplateStatus } from '@app/modules/vault/components/common/common-file-view-with-groups/individual-group-files-list-items/individual-group-files-list-items.component';

@Pipe({
  name: 'getTemplateStatusLabel',
})
export class GetTemplateStatusLabel implements PipeTransform {
  private templateStatusLabels: Record<string, string> = {
    [TemplateStatus.notStarted]: 'Not Started',
    [TemplateStatus.workingOnIt]: 'Working on it',
    [TemplateStatus.review]: 'Review',
    [TemplateStatus.needsAttention]: 'Needs Attention',
    [TemplateStatus.complete]: 'Complete',
  };

  transform(status: TemplateStatus | string | null | undefined): string {
    if (!status) {
      return this.templateStatusLabels[TemplateStatus.notStarted];
    }

    return this.templateStatusLabels[status] ?? String(status);
  }
}
